/* eslint-disable no-console */
import ReactDOM from 'react-dom';
import React from 'react';
import PropertyTaxes from './react/PropertyTaxes';

const transformData = (data) => {
  const rootArray = Object.keys(data).sort((a, b) => {
    const aGemeinde =
      data[a] && data[a].gemeinde ? data[a].gemeinde.toLowerCase() : '';
    const bGemeinde =
      data[b] && data[b].gemeinde ? data[b].gemeinde.toLowerCase() : '';
    if (aGemeinde === 'stuttgart') {
      return -1;
    }
    if (bGemeinde === 'stuttgart') {
      return 1;
    }
    return aGemeinde.localeCompare(bGemeinde);
  });
  return rootArray.map(key => (data[key] ? {
    city: data[key].gemeinde,
    rate: data[key].hebesatz,
  } : {}));
};

const getItemsFromScript = $script => new Promise((resolve) => {
  if (!$script) {
    return resolve([]);
  }

  const json = JSON.parse($script.textContent);

  if (!json || json.length === 0) {
    console.error('No data found in #bwHeaderNavigation');
    return resolve([]);
  }

  const data = transformData(json);

  return resolve(data);
});

document.querySelectorAll('.property-taxes').forEach(($el) => {
  const $checkbox = $el.querySelector('.property-taxes__checkbox .checkbox__input');
  const $content = $el.querySelector('.property-taxes__container');
  if ($checkbox && $content) {
    $checkbox.addEventListener('change', (e) => {
      if (e.target) {
        $content.setAttribute('aria-hidden', !e.target.checked);
      }
    });
  }

  const $root = $el.querySelector('.property-taxes__root');
  const $script = $el.querySelector('#grundsteuerData');

  if (!$root || !$script) {
    console.error('Property taxes root element not found or script tag not found');
    return;
  }

  getItemsFromScript($script).then((data) => {
    ReactDOM.render(<PropertyTaxes data={data} />, $root);
  });
});
